<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 12.0878L12.2328 15.1592V9.01642L16 12.0878Z" fill="#343A3F" />
        <path d="M16 3.73802L12.2328 6.80939V3.73802V0.666656L16 3.73802Z" fill="#343A3F" />
        <path
            d="M7.45522 7.88432L4.86403 12.7836H0V11.3919H4.10978L6.28986 7.12396L7.45522 7.88432Z"
            fill="#343A3F"
        />
        <path
            d="M4.85928 3.04221L9.82193 11.392H14.3203V12.7836H9.0772L4.11454 4.43384H0V3.04221H4.85928Z"
            fill="#343A3F"
        />
        <path
            d="M14.3204 3.04221V4.43384H9.8221L8.25109 6.79036L7.09321 6.01844L9.07737 3.04221H14.3204Z"
            fill="#343A3F"
        />
    </svg>
</template>

<script>
export default {
    name: 'SplitPromotionIcon',
};
</script>
